var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6271_2601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z",
    fill: "#996CFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.25C6.25 4.44891 6.32902 4.63968 6.46967 4.78033C6.61032 4.92098 6.80109 5 7 5C7.19891 5 7.38968 4.92098 7.53033 4.78033C7.67098 4.63968 7.75 4.44891 7.75 4.25C7.75 4.05109 7.67098 3.86032 7.53033 3.71967C7.38968 3.57902 7.19891 3.5 7 3.5C6.80109 3.5 6.61032 3.57902 6.46967 3.71967C6.32902 3.86032 6.25 4.05109 6.25 4.25ZM7.375 6H6.625C6.55625 6 6.5 6.05625 6.5 6.125V10.375C6.5 10.4437 6.55625 10.5 6.625 10.5H7.375C7.44375 10.5 7.5 10.4437 7.5 10.375V6.125C7.5 6.05625 7.44375 6 7.375 6Z",
    fill: "#996CFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6271_2601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon2);
export default __webpack_public_path__ + "static/media/infoicon2.48a8f0b047aeeedc9e8c1bb5b7acb914.svg";
export { ForwardRef as ReactComponent };